var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderListWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1215 6.75H16.8697V7.87324C16.8697 9.1125 15.8625 10.125 14.618 10.125C13.3787 10.125 12.3662 9.11777 12.3662 7.87324V6.75H7.86797V7.87324C7.86797 9.1125 6.86074 10.125 5.61621 10.125C4.37695 10.125 3.36445 9.11777 3.36445 7.87324V6.75H1.12324C1.12324 17.9982 0 27 0 27H20.25C20.2447 27 19.1215 17.9982 19.1215 6.75ZM5.62148 9.00176C6.24375 9.00176 6.74473 8.50078 6.74473 7.87852V5.62676C6.74473 3.75996 8.25293 2.25176 10.1197 2.25176C11.9865 2.25176 13.4947 3.75996 13.4947 5.62676V7.87852C13.4947 8.50078 13.9957 9.00176 14.618 9.00176C15.2402 9.00176 15.7412 8.50078 15.7412 7.87852V5.62676C15.7465 2.5207 13.2258 0 10.1197 0C7.01367 0 4.49297 2.5207 4.49297 5.62676V7.87852C4.49824 8.49551 4.99922 9.00176 5.62148 9.00176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderListWhite);
export default __webpack_public_path__ + "static/media/order-list-white.19804895095eec620d727e180b434f9f.svg";
export { ForwardRef as ReactComponent };